<template>
    <div class="database-view" v-if="section" v-route-title="section.name + '信息列表'">
        <div class="yq-news-section-list-page-head">
            {{section.name}}
        </div>
        <div class="clear"></div>
        <div class="gengduo">
            <news-query v-if="datasource" :datasource="datasource" :time-field="$route.query.timeField"
                        :time-interval="$route.query.timeInterval" @search="search"></news-query>
            <div v-if="data">
                <news-list :data="data.content" :datasource="datasource" view-name="list"
                           @show-details="showDetails"></news-list>
            </div>
            <div class="magin10"></div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionService from '../../service/section'
    import statSectionService from '../../service/stat-section'
    import datasourceConfigService from '../../service/datasource-config'
    import NewsList from '../../components/common/NewsList'
    import NewsQuery from '../../components/common/NewsQuery'
    import qs from 'qs'

    export default {
        name: "StatSectionNewsList",
        components: {NewsList, NewsQuery},
        data(){
            return {
                section: null,
                datasource: null,
                data: null,
                query: null
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                const response = await sectionService.getSection(this.$route.query.sectionId,
                    {templateId: this.$route.query.templateId})
                this.section = response.data
                const datasource = (await datasourceConfigService.getDatasourceConfig(this.$route.query.datasourceId)).data
                datasource.fields = JSON.parse(datasource.fields)
                this.datasource = datasource
                await this.fetchData(1)
            },
            async fetchData(page) {
                const params = {
                    pageId: this.$route.query.pageId,
                    templateId: this.$route.query.templateId,
                    sectionId: this.$route.query.sectionId,
                    dateStatInterval: this.$route.query.dateStatInterval,
                    path: this.$route.query.path,
                    viewName: 'list',
                    page: page - 1, size: 10,
                    sort: this.$route.query.timeField+',DESC'
                }
                if(this.query){
                    params.query = this.query
                }else{
                    params.timeInterval = this.$route.query.timeInterval
                }
                const response = await statSectionService.search(params)
                this.data = response.data
            },
            search(query){
                this.query = query
                this.fetchData(1)
            },
            showDetails(id){
                const url  = document.location.origin + document.location.pathname + '#/main/news-details'
                const params = {
                    id,
                    datasourceId: this.$route.query.datasourceId,
                }
                window.open(url+'?'+qs.stringify(params, {arrayFormat: 'repeat'}), '_blank')
            }
        }
    }
</script>

<style scoped>

</style>
